import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// Inline SVGs to avoid loading lucide-react in critical path
function MenuIcon() {
  return <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-298">
      <line x1="4" x2="20" y1="12" y2="12" data-id="element-299" />
      <line x1="4" x2="20" y1="6" y2="6" data-id="element-300" />
      <line x1="4" x2="20" y1="18" y2="18" data-id="element-301" />
    </svg>;
}
function CloseIcon() {
  return <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-302">
      <path d="M18 6 6 18" data-id="element-303" />
      <path d="m6 6 12 12" data-id="element-304" />
    </svg>;
}
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) closeMenu();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, closeMenu]);
  // Toggle menu-open class — no scroll lock to avoid blocking mobile touch scroll
  useEffect(() => {
    document.body.classList.toggle('menu-open', isOpen);
    return () => {
      document.body.classList.remove('menu-open');
    };
  }, [isOpen]);
  const handleNavigateToShop = () => {
    navigate('/tienda');
  };
  return <>
      <nav className="sticky top-0 z-[9999] bg-[#0A0A0B]/98 border-b border-gold/15 h-[56px] sm:h-[70px] flex items-center justify-between px-3 sm:px-[5%]" role="navigation" aria-label="Navegación principal" style={{
      touchAction: 'manipulation'
    }} data-id="element-305">
        <div className="font-serif italic text-gold text-base sm:text-xl font-bold tracking-[1.5px] sm:tracking-[2px]" data-id="element-306">
          EL CÓDIGO 888
        </div>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center" data-id="element-307">
          <a href="#que-es" className="text-white text-[11px] font-bold uppercase tracking-[1.5px] transition-colors hover:text-gold mr-5" data-id="element-308">
            Qué es el Código 888
          </a>
          <a href="#mecanismo" className="text-white text-[11px] font-bold uppercase tracking-[1.5px] transition-colors hover:text-gold mr-5" data-id="element-309">
            Cómo Funciona
          </a>
          <a href="#resultados" className="text-gold text-[11px] font-extrabold uppercase border-b-2 border-gold pb-[2px] mr-5" data-id="element-310">
            Resultados
          </a>
          <a href="#acceso-completo" className="text-white text-[11px] font-bold uppercase tracking-[1.5px] transition-colors hover:text-gold mr-5" data-id="element-311">
            Lo que incluye
          </a>
          <button onClick={() => navigate('/area-usuario')} className="relative bg-gradient-to-r from-gold via-yellow-400 to-gold text-dark text-[11px] font-black uppercase tracking-[1.5px] px-6 py-2.5 rounded-full hover:scale-105 transition-all duration-300 flex items-center gap-2 shadow-[0_0_20px_rgba(212,175,55,0.4)] hover:shadow-[0_0_30px_rgba(212,175,55,0.6)] overflow-hidden group" style={{
          animation: 'pulseGlow 3s ease-in-out infinite'
        }} data-id="element-312">
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent -translate-x-full group-hover:animate-shimmer" data-id="element-313" />
            <svg className="w-4 h-4 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-314">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" data-id="element-315"></path>
            </svg>
            <span className="relative z-10" data-id="element-316">Área de Usuario</span>
          </button>
        </div>

        {/* Mobile Hamburger */}
        <button className="lg:hidden text-gold p-2 min-w-[44px] min-h-[44px] flex items-center justify-center" onClick={toggleMenu} aria-label={isOpen ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={isOpen} aria-controls="mobile-menu" data-id="element-317">
          {isOpen ? <CloseIcon data-id="element-318" /> : <MenuIcon data-id="element-319" />}
        </button>
      </nav>

      {/* Mobile Overlay */}
      {isOpen && <>
          {/* Backdrop */}
          <div className="fixed inset-0 bg-black/50 z-[9997] lg:hidden" onClick={closeMenu} aria-hidden="true" data-id="element-320" />
          <div id="mobile-menu" role="dialog" aria-modal="true" aria-label="Menú de navegación" className="fixed top-[56px] sm:top-[70px] left-0 right-0 bottom-0 bg-[#0A0A0B] z-[9998] flex flex-col items-center pt-10 space-y-6 sm:space-y-8 lg:hidden overflow-y-auto" style={{
        WebkitOverflowScrolling: 'touch',
        overscrollBehaviorY: 'contain'
      }} data-id="element-321">
            <a href="#que-es" onClick={closeMenu} className="text-white text-sm font-bold uppercase tracking-[2px] min-h-[44px] flex items-center justify-center w-full" data-id="element-322">
              Qué es el Código 888
            </a>
            <a href="#mecanismo" onClick={closeMenu} className="text-white text-sm font-bold uppercase tracking-[2px] min-h-[44px] flex items-center justify-center w-full" data-id="element-323">
              Cómo Funciona
            </a>
            <a href="#resultados" onClick={closeMenu} className="text-gold text-sm font-bold uppercase tracking-[2px] min-h-[44px] flex items-center justify-center w-full" data-id="element-324">
              Resultados
            </a>
            <a href="#acceso-completo" onClick={closeMenu} className="text-gold text-sm font-bold uppercase tracking-[2px] min-h-[44px] flex items-center justify-center w-full" data-id="element-325">
              Lo que incluye
            </a>
            <button onClick={() => {
          closeMenu();
          navigate('/area-usuario');
        }} className="relative mt-2 bg-gradient-to-r from-gold via-yellow-400 to-gold text-dark text-sm font-black uppercase tracking-[2px] px-8 py-3.5 rounded-full hover:scale-105 transition-all duration-300 flex items-center justify-center gap-2 shadow-[0_0_20px_rgba(212,175,55,0.4)] hover:shadow-[0_0_30px_rgba(212,175,55,0.6)] overflow-hidden group min-h-[44px]" style={{
          animation: 'pulseGlow 3s ease-in-out infinite'
        }} data-id="element-326">
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent -translate-x-full group-hover:animate-shimmer" data-id="element-327" />
              <svg className="w-5 h-5 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-328">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" data-id="element-329"></path>
              </svg>
              <span className="relative z-10" data-id="element-330">Área de Usuario</span>
            </button>
          </div>
        </>}
    </>;
}